<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-seat`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39 4a2 2 0 012 2v12h1a2 2 0 012 2v19a2 2 0 01-2 2h-5v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3H15v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3H6a2 2 0 01-2-2V20a2 2 0 012-2h1V6a2 2 0 011.85-1.995L9 4h30zM8.975 22H8v15h32V22l-.975-.001L39 22h-3.429v7.433H12.186V22H8.975zm7.211-4v7.433h15.385V18H37V8H11v10h5.186z"/></svg>
</template>
<script>

export default {
  name: 'IconSeat',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
